import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { TodayBudgetConfirm } from "./TodayBudgetConfirm";

// The control that clears what holds the probe, right next to the reason: Unpause, or Raise today's budget (owner).
export const ProbeWaitFix = ({ blocked, gate, viewer, onUnpause, onRaise }) => {
  const [amount, setAmount] = useState("");
  const [pending, setPending] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const raise = blocked?.code === "budget_used_up";
  if (!blocked || !["gate_paused", "budget_used_up"].includes(blocked.code)) return null;
  if (raise && !viewer?.can_raise_budget) {
    return (
      <p data-testid="ai-probe-fix-owner-only" className="mt-2 text-xs text-muted-foreground">
        Only an owner account can raise today's budget{viewer?.why ? ` (${viewer.why})` : ""}.
      </p>
    );
  }
  const n = Number(amount);
  const run = async (fn, value) => {
    setBusy(true);
    setError("");
    try {
      await fn(value);
      setAmount("");
    } catch (e) {
      setError(e?.response?.data?.detail || "That did not work. Please retry.");
    } finally {
      setBusy(false);
      setPending(null);
    }
  };
  return (
    <div data-testid="ai-probe-fix" className="mt-2 flex flex-wrap items-center gap-2">
      <input
        data-testid="ai-probe-fix-amount"
        aria-label={raise ? "New budget for today (USD)" : "Budget for today (USD)"}
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        inputMode="decimal"
        placeholder={String((raise ? gate?.override_max_usd : gate?.cap_usd) ?? "")}
        className="w-28 rounded-full border border-border bg-background px-4 h-9 text-sm outline-none focus:ring-2 ring-accent/40"
      />
      <Button
        data-testid={raise ? "ai-probe-raise-btn" : "ai-probe-unpause-btn"}
        size="sm"
        className="rounded-full h-9 px-4 font-bold gap-2 transition-transform active:scale-95"
        disabled={busy || !n}
        onClick={() => (raise ? setPending(n) : run(onUnpause, n))}
      >
        {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
        {raise ? "Raise today's budget" : "Unpause with this budget"}
      </Button>
      {error && <span data-testid="ai-probe-fix-error" className="text-xs text-rose-700">{error}</span>}
      {raise && (
        <TodayBudgetConfirm gate={gate} amount={pending} busy={busy} onCancel={() => setPending(null)} onConfirm={() => run(onRaise, pending)} />
      )}
    </div>
  );
};
